var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[(_vm.$vuetify.breakpoint.smAndUp)?_c('w-desktop'):_c('w-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }